import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { pillCls } from "@/components/EduBlocks";
import { BIRTHSTONES, gemLabel, shopGemUrl, designGemUrl } from "@/lib/gems";

export function GemButtons({ gem, center = false, hideShop = false, tid = "" }: { gem: string; center?: boolean; hideShop?: boolean; tid?: string }) {
  return (
    <div className={`flex flex-wrap gap-3 ${center ? "justify-center" : ""}`}>
      {!hideShop && <Link to={shopGemUrl(gem)} className={pillCls + " !px-6"} data-testid={tid ? `${tid}-shop` : `shop-gem-${gem}`}>Shop {gemLabel(gem)}</Link>}
      <Link to={designGemUrl(gem)} className={hideShop ? pillCls + " !px-6" : "inline-flex items-center text-[10px] tracking-[0.2em] uppercase underline underline-offset-4 hover:text-[var(--c-primary)]"} data-testid={tid ? `${tid}-design` : `design-gem-${gem}`}>Design yours</Link>
    </div>
  );
}

export function BirthstoneFinder({ b }: any) {
  const [m, setM] = useState(new Date().getMonth());
  const [items, setItems] = useState<any[] | null>(null);
  const gem = BIRTHSTONES[m].gems.join(",");
  useEffect(() => {
    let live = true; setItems(null);
    api.get("/products", { params: { gem, limit: 8 } }).then((r) => live && setItems(r.data.items)).catch(() => live && setItems([]));
    return () => { live = false; };
  }, [gem]);
  return (
    <section className="max-w-[1300px] mx-auto px-5 md:px-12 py-14 md:py-20" data-testid="birthstone-finder">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-display uppercase tracking-[0.08em] text-3xl md:text-4xl">{b.heading || "Find Their Birthstone"}</h2>
        {b.intro && <p className="mt-4 text-sm md:text-[15px] text-neutral-600 leading-relaxed">{b.intro}</p>}
      </div>
      <div className="mt-8 flex flex-wrap justify-center gap-2" role="tablist">
        {BIRTHSTONES.map((x, i) => (
          <button key={x.month} role="tab" aria-selected={i === m} onClick={() => setM(i)} data-testid={`birthstone-month-${x.month.toLowerCase()}`}
            className={`rounded-full border px-4 py-2 text-[10px] tracking-[0.2em] uppercase transition-colors ${i === m ? "bg-neutral-900 text-white border-neutral-900" : "border-neutral-300 hover:border-neutral-900"}`}>{x.month.slice(0, 3)}</button>
        ))}
      </div>
      <div className="mt-10 text-center" data-testid="birthstone-result">
        <p className="eyebrow text-neutral-500">{BIRTHSTONES[m].month} birthstone</p>
        <p className="mt-2 font-display text-3xl" data-testid="birthstone-gem-name">{gemLabel(gem)}</p>
        <div className="mt-6"><GemButtons gem={gem} center tid="birthstone" hideShop={items !== null && !items.length} /></div>
      </div>
      {items === null ? <div className="h-40" /> : items.length ? (
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-12 md:gap-x-8" data-testid="birthstone-products">
          {items.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
        </div>
      ) : (
        <p className="mt-10 text-center text-sm text-neutral-600 max-w-md mx-auto" data-testid="birthstone-empty">No {gemLabel(gem).toLowerCase()} pieces are in the shop right now — we'd love to design one for you.</p>
      )}
    </section>
  );
}
